import styled from "styled-components";

import { ColorGrayDark, ColorGrayLight, ColorGrayLightest, ColorNeutralBlack, ColorNeutralWhite } from "ds/Core";

import { devices } from "../styles/breakpoints";
import { getSpacing } from "../styles/spacing";
import { TStyledButton } from "./types";

export const StyledButton = styled.button<TStyledButton>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ width = "max-content" }) => width};
  ${({ minWidth }) => minWidth && `min-width: ${minWidth};`}
  min-height: ${({ minHeight = "64px" }) => minHeight};
  border-radius: ${({ round = "90px" }) => round};
  cursor: pointer;
  box-sizing: border-box;
  ${({ margin, padding }) => `
    padding: ${getSpacing(padding)};
    margin: ${getSpacing(margin)};
  `}
  ${({ state, theme: { spaces } }) => {
    switch (state) {
      case "light":
        return `
          background: ${ColorNeutralWhite};
          border: 1px solid ${ColorGrayLight};
          &:disabled {
            background: ${ColorGrayLightest};
            border: 1px solid transparent;
          }
          &:hover:not(:disabled) {
            background: ${ColorGrayLightest};
          }
        `;
      case "light-contrast":
        return `
            background: ${ColorNeutralWhite};
            border: 2px solid ${ColorNeutralBlack};
            &:disabled {
              background: ${ColorGrayLightest};
              border-color: ${ColorGrayLightest};
            }
            &:hover:not(:disabled) {
              background: ${ColorGrayLightest};
            }
            & > span {
              font-weight: 500;
            }
          `;
      case "dark":
        return `
          padding: 0 ${spaces.s};
          background: ${ColorNeutralBlack};
          border: 1px solid ${ColorNeutralBlack};
          box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.05);
          &:hover {
            background: ${ColorGrayDark};
            border: 1px solid ${ColorGrayDark};
          }
        `;
      case "primary":
        return `
          border: none;
          background: #F6F6F7;
          border-radius: 8px;
          &:hover {
            > span {
              color: ${ColorGrayDark};
            }
            > svg {
              path {
                fill: ${ColorGrayDark};
              }
            }
          }
        `;
      default:
        return `
          min-height: 32px;
          border: none;
          background: transparent;
          border-radius: 0px;
          &:hover {
            > span {
              color: ${ColorGrayDark};
            }
            > svg {
              path {
                fill: ${ColorGrayDark};
              }
            }
          }
      `;
    }
  }}
  &:disabled {
    cursor: not-allowed;
  }
  @media ${devices.mobile} {
    ${({ state }) =>
      state !== "default"
        ? `
            width: 100%;
          `
        : ""}
  }
`;
